<div class="container-lista" *ngFor="let key of opcoesKeys">
  <button (click)="selecionarAcao(key)">
    <ion-icon *ngIf="opcoes[key]?.icone" name="{{opcoes[key]?.icone}}"></ion-icon>
    <div class="conteudo">
      <span>{{opcoes[key]?.texto}}</span>
    </div>
  </button>
</div>